/* eslint-disable @typescript-eslint/no-require-imports */

const registerByEditionLocale = {
    "en-au": (dayjs) => {
        require("dayjs/locale/en-au.js");
        dayjs.locale("en-au");
    },
    "en-ca": (dayjs) => {
        require("dayjs/locale/en-ca.js");
        dayjs.locale("en-ca");
    },
    "en-gb": (dayjs) => {
        require("dayjs/locale/en-gb.js");
        dayjs.locale("en-gb");
    },
    "en-hk": (dayjs) => {
        require("dayjs/locale/en.js");
        dayjs.locale("en");
    },
    "en-in": (dayjs) => {
        require("dayjs/locale/en-in.js");
        dayjs.locale("en-in");
    },
    "en-my": (dayjs) => {
        require("dayjs/locale/en.js");
        dayjs.locale("en");
    },
    "en-us": (dayjs) => {
        require("dayjs/locale/en.js");
        dayjs.locale("en");
    },
    "es-ar": (dayjs) => {
        require("dayjs/locale/es.js");
        dayjs.locale("es");
    },
    "es-es": (dayjs) => {
        require("dayjs/locale/es.js");
        dayjs.locale("es");
    },
    "es-mx": (dayjs) => {
        require("dayjs/locale/es-mx.js");
        dayjs.locale("es-mx");
    },
    "es-us": (dayjs) => {
        require("dayjs/locale/es-us.js");
        dayjs.locale("es-us");
    },
    "ja-jp": (dayjs) => {
        require("dayjs/locale/ja.js");
        dayjs.locale("ja");
    },
    "ko-kr": (dayjs) => {
        require("dayjs/locale/ko.js");
        dayjs.locale("ko");
    },
    "pt-br": (dayjs) => {
        require("dayjs/locale/pt-br.js");
        dayjs.locale("pt-br");
    },
    "th-th": (dayjs) => {
        require("dayjs/locale/th.js");
        dayjs.locale("th");
    },
    "vi-vn": (dayjs) => {
        require("dayjs/locale/vi.js");
        dayjs.locale("vi");
    },
};

export function registerDayjsEditionLocale(dayjs, editionLocale) {
    const register = registerByEditionLocale[editionLocale];
    if (register) {
        register(dayjs);
        return;
    }
    console.warn(
        `dayjs: no locale mapping found for edition locale "${editionLocale}", falling back to "en"`,
    );
    require("dayjs/locale/en.js");
    dayjs.locale("en");
}
